import request from '@/util/request';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/prePay/electricity/charge/page', Object.assign({}, options, { params }));

// 汇总信息
export const getSumInfoApi = (params, options) =>
  request.get(
    '/api/v4ward/prePay/electricity/charge/count',
    Object.assign({}, options, { params })
  );

// 日志列表
export const getLogListApi = (params, options) =>
  request.get(
    '/api/v4ward/prePay/electricity/unLegal/page',
    Object.assign({}, options, { params })
  );

// 充值扣缴详情
export const detailApi = (params, options) =>
  request.get(
    '/api/v4ward/prePay/electricity/charge/detail',
    Object.assign({}, options, { params })
  );

// 根据房产获取预缴电表列表
export const getMetersApi = (params, options) =>
  request.get(
    '/api/v4ward/prePay/electricity/meter/getMeterByPropertyId',
    Object.assign({}, options, { params })
  );
